import React, {PropsWithChildren} from 'react';

import {cssClassName} from '../../../util';

interface IProps extends React.TableHTMLAttributes<any> {
}

type Props = PropsWithChildren<IProps>;

export default class DataTableBody extends React.Component<Props, {}> {
	render(): React.ReactNode {
		const {children, className, ...attrs} = this.props;
		return (
			<tbody className={cssClassName('mdc-data-table__content', className)} {...attrs}>
				{children}
			</tbody>
		);
	}
}
